"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: referral/referral-state.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Freferral%2Freferral-state.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignProgress = exports.RedemptionRewardWindow = exports.RedeemerState = exports.ReferrerState = exports.ReferralState = void 0;
const amount_1 = require("../common/amount");
const referral_invite_status_1 = require("../common/referral-invite-status");
const referral_campaign_1 = require("./referral-campaign");
const referral_code_status_1 = require("./referral-code-status");
const protobufPackage = 'com.step.referral.proto';
function createBaseReferralState() {
    return {
        referrer: exports.ReferrerState.fromPartial({}),
        redeemer: undefined,
        redemptionRewardWindow: exports.RedemptionRewardWindow.fromPartial({}),
    };
}
exports.ReferralState = {
    fromJSON(object) {
        const message = {
            referrer: isSet(object.referrer)
                ? exports.ReferrerState.fromJSON(object.referrer)
                : exports.ReferrerState.fromPartial({}),
            redemptionRewardWindow: isSet(object.redemptionRewardWindow)
                ? exports.RedemptionRewardWindow.fromJSON(object.redemptionRewardWindow)
                : exports.RedemptionRewardWindow.fromPartial({}),
        };
        if (isSet(object.redeemer)) {
            message.redeemer = exports.RedeemerState.fromJSON(object.redeemer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.referrer !== undefined) {
            obj.referrer = exports.ReferrerState.toJSON(message.referrer);
        }
        if (message.redeemer !== undefined) {
            obj.redeemer = exports.RedeemerState.toJSON(message.redeemer);
        }
        if (message.redemptionRewardWindow !== undefined) {
            obj.redemptionRewardWindow = exports.RedemptionRewardWindow.toJSON(message.redemptionRewardWindow);
        }
        return obj;
    },
    create(base) {
        return exports.ReferralState.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReferralState();
        message.referrer = (object.referrer !== undefined && object.referrer !== null)
            ? exports.ReferrerState.fromPartial(object.referrer)
            : exports.ReferrerState.fromPartial({});
        message.redeemer = (object.redeemer !== undefined && object.redeemer !== null)
            ? exports.RedeemerState.fromPartial(object.redeemer)
            : undefined;
        message.redemptionRewardWindow =
            (object.redemptionRewardWindow !== undefined && object.redemptionRewardWindow !== null)
                ? exports.RedemptionRewardWindow.fromPartial(object.redemptionRewardWindow)
                : exports.RedemptionRewardWindow.fromPartial({});
        return message;
    },
};
function createBaseReferrerState() {
    return {
        code: '',
        link: '',
        campaign: referral_campaign_1.ReferralCampaign.fromPartial({}),
        referrerReward: undefined,
        redeemerReward: amount_1.Amount.fromPartial({}),
        progress: undefined,
        status: referral_code_status_1.ReferralCodeStatus.INVALID_REFERRAL_CODE_STATUS,
    };
}
exports.ReferrerState = {
    fromJSON(object) {
        const message = {
            code: isSet(object.code) ? globalThis.String(object.code) : '',
            link: isSet(object.link) ? globalThis.String(object.link) : '',
            campaign: isSet(object.campaign)
                ? referral_campaign_1.ReferralCampaign.fromJSON(object.campaign)
                : referral_campaign_1.ReferralCampaign.fromPartial({}),
            redeemerReward: isSet(object.redeemerReward)
                ? amount_1.Amount.fromJSON(object.redeemerReward)
                : amount_1.Amount.fromPartial({}),
            status: isSet(object.status)
                ? (0, referral_code_status_1.referralCodeStatusFromJSON)(object.status)
                : referral_code_status_1.ReferralCodeStatus.INVALID_REFERRAL_CODE_STATUS,
        };
        if (isSet(object.referrerReward)) {
            message.referrerReward = amount_1.Amount.fromJSON(object.referrerReward);
        }
        if (isSet(object.progress)) {
            message.progress = exports.CampaignProgress.fromJSON(object.progress);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.code !== '') {
            obj.code = message.code;
        }
        if (message.link !== '') {
            obj.link = message.link;
        }
        if (message.campaign !== undefined) {
            obj.campaign = referral_campaign_1.ReferralCampaign.toJSON(message.campaign);
        }
        if (message.referrerReward !== undefined) {
            obj.referrerReward = amount_1.Amount.toJSON(message.referrerReward);
        }
        if (message.redeemerReward !== undefined) {
            obj.redeemerReward = amount_1.Amount.toJSON(message.redeemerReward);
        }
        if (message.progress !== undefined) {
            obj.progress = exports.CampaignProgress.toJSON(message.progress);
        }
        if (message.status !== referral_code_status_1.ReferralCodeStatus.INVALID_REFERRAL_CODE_STATUS) {
            obj.status = (0, referral_code_status_1.referralCodeStatusToJSON)(message.status);
        }
        return obj;
    },
    create(base) {
        return exports.ReferrerState.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReferrerState();
        message.code = object.code ?? '';
        message.link = object.link ?? '';
        message.campaign = (object.campaign !== undefined && object.campaign !== null)
            ? referral_campaign_1.ReferralCampaign.fromPartial(object.campaign)
            : referral_campaign_1.ReferralCampaign.fromPartial({});
        message.referrerReward = (object.referrerReward !== undefined && object.referrerReward !== null)
            ? amount_1.Amount.fromPartial(object.referrerReward)
            : undefined;
        message.redeemerReward = (object.redeemerReward !== undefined && object.redeemerReward !== null)
            ? amount_1.Amount.fromPartial(object.redeemerReward)
            : amount_1.Amount.fromPartial({});
        message.progress = (object.progress !== undefined && object.progress !== null)
            ? exports.CampaignProgress.fromPartial(object.progress)
            : undefined;
        message.status = object.status ?? referral_code_status_1.ReferralCodeStatus.INVALID_REFERRAL_CODE_STATUS;
        return message;
    },
};
function createBaseRedeemerState() {
    return {
        code: '',
        link: '',
        referrerUserId: '',
        campaign: referral_campaign_1.ReferralCampaign.fromPartial({}),
        status: referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS,
        redeemerReward: amount_1.Amount.fromPartial({}),
        startedRedemptionAtMs: '0',
        rewardedAtMs: '0',
    };
}
exports.RedeemerState = {
    fromJSON(object) {
        const message = {
            code: isSet(object.code) ? globalThis.String(object.code) : '',
            link: isSet(object.link) ? globalThis.String(object.link) : '',
            campaign: isSet(object.campaign)
                ? referral_campaign_1.ReferralCampaign.fromJSON(object.campaign)
                : referral_campaign_1.ReferralCampaign.fromPartial({}),
            status: isSet(object.status)
                ? (0, referral_invite_status_1.referralInviteStatusFromJSON)(object.status)
                : referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS,
            redeemerReward: isSet(object.redeemerReward)
                ? amount_1.Amount.fromJSON(object.redeemerReward)
                : amount_1.Amount.fromPartial({}),
            startedRedemptionAtMs: isSet(object.startedRedemptionAtMs)
                ? globalThis.String(object.startedRedemptionAtMs)
                : '0',
        };
        if (isSet(object.referrerUserId)) {
            message.referrerUserId = globalThis.String(object.referrerUserId);
        }
        if (isSet(object.rewardedAtMs)) {
            message.rewardedAtMs = globalThis.String(object.rewardedAtMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.code !== '') {
            obj.code = message.code;
        }
        if (message.link !== '') {
            obj.link = message.link;
        }
        if (message.referrerUserId !== undefined && message.referrerUserId !== '') {
            obj.referrerUserId = message.referrerUserId;
        }
        if (message.campaign !== undefined) {
            obj.campaign = referral_campaign_1.ReferralCampaign.toJSON(message.campaign);
        }
        if (message.status !== referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS) {
            obj.status = (0, referral_invite_status_1.referralInviteStatusToJSON)(message.status);
        }
        if (message.redeemerReward !== undefined) {
            obj.redeemerReward = amount_1.Amount.toJSON(message.redeemerReward);
        }
        if (message.startedRedemptionAtMs !== '0') {
            obj.startedRedemptionAtMs = message.startedRedemptionAtMs;
        }
        if (message.rewardedAtMs !== undefined && message.rewardedAtMs !== '0') {
            obj.rewardedAtMs = message.rewardedAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.RedeemerState.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRedeemerState();
        message.code = object.code ?? '';
        message.link = object.link ?? '';
        message.referrerUserId = object.referrerUserId ?? '';
        message.campaign = (object.campaign !== undefined && object.campaign !== null)
            ? referral_campaign_1.ReferralCampaign.fromPartial(object.campaign)
            : referral_campaign_1.ReferralCampaign.fromPartial({});
        message.status = object.status ?? referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS;
        message.redeemerReward = (object.redeemerReward !== undefined && object.redeemerReward !== null)
            ? amount_1.Amount.fromPartial(object.redeemerReward)
            : amount_1.Amount.fromPartial({});
        message.startedRedemptionAtMs = object.startedRedemptionAtMs ?? '0';
        message.rewardedAtMs = object.rewardedAtMs ?? '0';
        return message;
    },
};
function createBaseRedemptionRewardWindow() {
    return { endsAtMs: '0', hasEnded: false };
}
exports.RedemptionRewardWindow = {
    fromJSON(object) {
        const message = {
            endsAtMs: isSet(object.endsAtMs) ? globalThis.String(object.endsAtMs) : '0',
            hasEnded: isSet(object.hasEnded) ? globalThis.Boolean(object.hasEnded) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.endsAtMs !== '0') {
            obj.endsAtMs = message.endsAtMs;
        }
        if (message.hasEnded !== false) {
            obj.hasEnded = message.hasEnded;
        }
        return obj;
    },
    create(base) {
        return exports.RedemptionRewardWindow.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRedemptionRewardWindow();
        message.endsAtMs = object.endsAtMs ?? '0';
        message.hasEnded = object.hasEnded ?? false;
        return message;
    },
};
function createBaseCampaignProgress() {
    return { referrals: 0, target: 0 };
}
exports.CampaignProgress = {
    fromJSON(object) {
        const message = {
            referrals: isSet(object.referrals) ? globalThis.Number(object.referrals) : 0,
        };
        if (isSet(object.target)) {
            message.target = globalThis.Number(object.target);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.referrals !== 0) {
            obj.referrals = Math.round(message.referrals);
        }
        if (message.target !== undefined && message.target !== 0) {
            obj.target = Math.round(message.target);
        }
        return obj;
    },
    create(base) {
        return exports.CampaignProgress.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCampaignProgress();
        message.referrals = object.referrals ?? 0;
        message.target = object.target ?? 0;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=referral-state.js.map